import * as bie from "react-bootstrap";
import { ErrorMessage, Field, Form, FormikProvider, useFormik } from "formik";
import * as Yup from "yup";
import Swal from "sweetalert2";
import { failureAlert, successAlert2 } from "./CommonUtils/SweetAlerts";
import { config } from "./CommonUtils/CommonURLS";
import { CommonAxiosGet, CommonAxiosPost } from "./CommonUtils/CommonAxios";
import md5 from "md5";
import { useState } from "react";

export default function ForgotPassword() {
  const [instStatus, setInstStatus] = useState(false);
  const forgotFormik = useFormik({
    initialValues: {
      institutionCode: "",
      newpassword: "",
      confirmpassword: "",
    },

    validationSchema: Yup.object({
      institutionCode: Yup.string()
        .required("Institution Code is required")
        .min(7, "Institution Code must be 7 characters")
        .max(7, "Institution Code must be 7 characters"),
      newpassword: Yup.string()
        .required("Enter New password")
        .min(8, "Password must be at least 8 characters")
        .matches(/[0-9]/, "Must contain at least one number")
        .matches(/[a-zA-Z]/, "Must contain at least one alphabet")
        .matches(/[@$!%*?&]/, "Must contain at least one special character")
        .matches(/[A-Z]/, "Must contain at least one uppercase letter")
        .matches(/[a-z]/, "Must contain at least one lowercase letter"),

      confirmpassword: Yup.string()
        .required("Confirm password")
        .oneOf([Yup.ref("newpassword")], "Passwords must match"),
    }),

    onSubmit: (val) => {
      const payload = {
        aiesheCode: val.institutionCode,
        newPassword: md5(val.newpassword),
        confirmPassword: md5(val.confirmpassword),
      };
      Swal.fire({
        text: "Are you sure you want to reset the password?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, Reset Password",
        cancelButtonText: "Cancel",
        backdrop: false,
      }).then((result) => {
        if (result.isConfirmed) {
          const url = config.url.API_URL + "forgetPassword";

          CommonAxiosPost(url, payload).then((res) => {
            if (res?.data?.scode === "01") {
              successAlert2(res?.data?.sdesc || "Password reset successfully");
            } else {
              failureAlert(res?.data?.sdesc || "Failed to reset password");
            }
          });
        }
      });
    },

  });

  const GetInstData = (id) => {
    const url = `${config.url.API_URL}getInstituteDtls?userId=${id}`;
    CommonAxiosGet(url).then((res) => {
      if (res.data.status === true) {
        setInstStatus(true);
      }
      else {
        failureAlert("Institution not found");
        forgotFormik.resetForm();
      }
    });
  };

  return (
    <>
      <div className="forgot-wrapper">
        <div className="forgot-card">
          <h4 className="forgot-title">Forgot Password </h4>
          <FormikProvider value={forgotFormik}>
            <Form
              autoComplete="off"
              onChange={forgotFormik.handleChange}
              onSubmit={forgotFormik.handleSubmit}
              className="form_adjust"
            >
              <bie.Row className="px-2 pt-3 mb-3">

                {/* Institution Code */}
                <bie.Row>
                  <bie.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3} className="mb-2">
                    <span className="field-mandatory">Institution Code :</span>
                  </bie.Col>
                  <bie.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3} className="mb-2">
                    <Field
                      type="text"
                      name="institutionCode"
                      className="form-control"
                      placeholder="Enter Institution Code"
                      autoComplete="off"
                      onChange={(e) => {
                        setInstStatus(false);
                        if (e.target.value.length === 7) {
                          GetInstData(e.target.value)
                        }
                      }}
                    />
                    <ErrorMessage
                      name="institutionCode"
                      component="div"
                      className="text-danger"
                    />
                  </bie.Col>
                </bie.Row>
                {instStatus && (<>
                  {/* New Password */}
                  <bie.Row>
                    <bie.Col xs={12} sm={12} md={12} lg={2} xl={2} xxl={2} className="mb-2">
                      <span className="field-mandatory">New Password</span>
                    </bie.Col>
                    <bie.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3} className="mb-2">
                      <Field
                        type="text"
                        name="newpassword"
                        className="form-control"
                        autoComplete="new-password"
                      />
                      <ErrorMessage
                        name="newpassword"
                        component="div"
                        className="text-danger"
                      />
                    </bie.Col>
                  </bie.Row>

                  {/* Confirm Password */}
                  <bie.Row>
                    <bie.Col xs={12} sm={12} md={12} lg={2} xl={2} xxl={2} className="mb-2">
                      <span className="field-mandatory">Confirm Password</span>
                    </bie.Col>
                    <bie.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3} className="mb-2">
                      <Field
                        type="password"
                        name="confirmpassword"
                        className="form-control"
                        autoComplete="new-password"
                      />
                      <ErrorMessage
                        name="confirmpassword"
                        component="div"
                        className="text-danger"
                      />
                    </bie.Col>
                  </bie.Row>
                </>)}
                {/* Submit */}
                <div className="d-flex flex-row justify-content-end pb-4">
                  <button type="submit" className="btn btn-primary btn-sm rounded">
                    Reset Password
                  </button>
                </div>

              </bie.Row>
            </Form>
          </FormikProvider>

        </div>
      </div>
    </>
  );
}
